import React from 'react'

// eslint-disable-next-line react/require-default-props
function AppleIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <g clipPath="url(#a)">
        <path
          d="M17.427 7.5c-.128.099-2.392 1.368-2.392 4.19 0 3.266 2.881 4.42 2.967 4.45-.013.07-.457 1.581-1.519 3.121-.946 1.355-1.935 2.708-3.439 2.708-1.503 0-1.89-.869-3.626-.869-1.692 0-2.293.898-3.669.898-1.375 0-2.335-1.254-3.438-2.794C1.033 17.395 0 14.586 0 11.92c0-4.277 2.795-6.545 5.546-6.545 1.462 0 2.68.954 3.598.954.873 0 2.235-1.012 3.898-1.012.63 0 2.895.058 4.385 2.183Zm-5.174-3.993c.688-.812 1.174-1.938 1.174-3.065 0-.156-.013-.314-.042-.442-1.119.042-2.45.741-3.253 1.668-.63.712-1.218 1.839-1.218 2.98 0 .172.029.344.042.399.07.013.186.028.3.028 1.004 0 2.267-.668 2.997-1.568Z"
          fill="#000"
        />
      </g>
      <defs>
        <clipPath id="a">
          <path fill="#fff" d="M0 0h18v22H0z" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default AppleIcon
